export default "__VITE_ASSET__KNCSt1iP__"